import { Button, Col } from 'react-bootstrap';
import { ITemplateData } from '@/services/template-data-service';

export default function ContactNavigation({ className, templateData }: { className: string; templateData: ITemplateData }) {
  return (
    <>
      <Col className={className} md={6} lg={12}>
        <span dangerouslySetInnerHTML={{ __html: templateData.footer.locationContact }} />
      </Col>
      <Col className={className} md={6} lg={12}>
        <Button variant="outline-primary" href="/contact" className="pt-2 pb-2 pl-3 pr-3">
          Contact
        </Button>
      </Col>
    </>
  );
}
